import React from 'react';
import { Socket } from 'socket.io-client';

import { AuthStatusEnum, IUser } from '@/types/auth.ts';

interface AuthContextType {
  login: AuthStatusEnum;
  setUserCookie: (value: string) => void;
  user: IUser | null;
  logOut: () => void;
  ws: Socket | null;
}

export const AuthContext = React.createContext<AuthContextType>(null!);
